import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import './Pagina.css';
import { Button } from '../button';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import {Helmet} from "react-helmet";

function Pagina () {
    const { Pagina } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [Pagina]);

    return (
        <>
            <Helmet>
          <meta charSet='utf-8'/>
          <title>Tekins | Páginas Web y SEO</title>
          <meta name="description" content= "Diseñamos sitios web y estrategias SEO centradas en la experiencia del usuario y el crecimiento del negocio." />
          <meta name="robots" content= "index, follow"></meta>
        </Helmet>
        <div className='pagina'>
        <h1>Página Web / SEO</h1> 
        </div>

  
        <div className='pagina-titulo'>       
         <h2 >Creamos proyectos web que marcan la diferencia.</h2>
        </div>   

        <div className='pagina-centro'>
                        
           
                   <p>Tu sitio web es el corazón de tu ecosistema digital. En Tekins diseñamos experiencias enfocadas en conversiones, accesibilidad y performance. Construimos interfaces personalizadas con componentes reutilizables y contenido optimizado.
                      <br/><br/>
                      Arrancamos entendiendo a tu audiencia, mapeando journeys y definimos la arquitectura de información. Desde esa base prototipamos, iteramos y lanzamos productos digitales que evolucionan contigo.

                      </p>
                      
        </div>

       
        <div className='pagina-row'>

        
        <div className='pagina-col'>
           <div className='pagina-col-content'>   
                   <p>  Acompañamos a tu equipo en cada fase: diseño UX/UI, desarrollo, integraciones, optimización de rendimiento y transferencia de conocimiento. Nuestro objetivo es que puedas gestionar tu plataforma con autonomía.  
                  </p>
                      </div>
</div>
        <div className='pagina-col-r'>
          <div className='pagina-row-ima'> 
                <img class="pagina-imagen-p" 
                src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80" 
                alt="Workshop de diseño web Tekins"/>
          </div>
        </div>
</div>

<div className='pagina-centro-2'>
                        
           
                   <p>Además de diseñar y desarrollar, activamos estrategias SEO técnicas y de contenido.</p>
                    <h2>¿Qué es SEO?</h2>
                <p>El SEO se centra en los resultados orgánicos: optimizamos sitio, contenido y autoridad para que te encuentren de manera natural.</p>


                     
                
        </div>
      
      
        <div className='pagina-row'>

        
<div className='pagina-col'>
<div className='pagina-row-ima'> 
        <img class="pagina-imagen-p" 
        src="https://images.unsplash.com/photo-1483478550801-ceba5fe50e8e?auto=format&fit=crop&w=900&q=80" 
        alt="Equipo SEO Tekins"/>
  </div>
  
</div>
<div className='pagina-col-r-2'>


<div className='pagina-col-content-2'>   
           <p>  El posicionamiento en buscadores consiste en mejorar la visibilidad de tu sitio en las SERPs. Trabajamos auditorías técnicas, optimización on-page, contenidos estratégicos y link building ético. Todo respaldado con dashboards para medir impacto.
 
          </p>
          <br/>
          <div className='col-button'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20cotizar%20una%20web%20con%20Tekins"> <button className='bt' >Cotizar</button> </a></div>
              </div>
  
</div>
</div>
        <Footer/>
        </>
    );
}

export default Pagina;
